module.exports = __webpack_public_path__ + "img/19.a1d264ef.png";